const buildReportRequest = (advancedFilters = [], programsAndSubprograms = []) => {
  const filters = advancedFilters.filter(filter => filter.value !== 'all' && filter.state);
  const selectedOrgIds = filters.filter(filter => filter.group === 'orgId').map(filter => filter.value);

  const request = {};
  if (selectedOrgIds.length > 0) {
    request.orgId = selectedOrgIds;
  }

  const groupId = filters.find(filter => filter.group === 'orgGroup')?.value;
  if (groupId) request.groupId = groupId;

  const programFilter = filters.find(filter => filter.group === 'programAndSubprogram');
  const programType = programsAndSubprograms.find(program => program.value === programFilter?.value)?.type;
  if (programType === 'program') request.program = programFilter.value;
  if (programType === 'subprogram') request.subprogram = programFilter.value;

  const provider = filters.find(filter => filter.group === 'provider')?.value;
  if (provider) request.provider = provider;

  return request;
};

export default buildReportRequest;
